// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.add-pathways-container {
    height: 82%;
    width: 460px;
    position: fixed;
    z-index: 99;
    top: 70px;
    right: 5px;
}

.add-pathways-container .path-img {
    border-radius: 13px;
    max-height: 250px;
    width: 100%;
}

.civ-remove {
    background: #d3d3d3;
    position: absolute;
    top: 0;
    right: 0;
    padding: 5px 10px;
    border: none;
    border-radius: 0 6px 0 6px;
}

.civ-paths-btn {
    background: rgba(100, 56, 180, 0.05);
    border: 1px solid #6438B4;
    border-radius: 50px;
    font-weight: 500;
    font-size: 14px;
    color: #6438B4;
    padding: 6px 16px;
    margin: 5px;
}

.civ-paths-btn i {
    display: none;
    cursor: pointer;
    margin-right: -5px;
    margin-left: 5px;
}

.civ-paths-btn:hover i {
    display: inline-block;
}

.civ-message-body {
    display: flex;
}

.civ-message-body.from {
    justify-content: flex-start;
}

.civ-message-body.to {
    justify-content: flex-end;
}

.civ-message {
    display: inline-block;
    border-radius: 1.5rem;
    margin-bottom: 15px;
    padding: 8px 20px;
    position: relative;
    /*font-size: 20px;*/
}

.civ-message-body.to .civ-message {
    background-color: #9b4dca;
    color: #fff;
    margin-left: 100px;
}

.civ-message-body.from .civ-message {
    background-color: #E5E4E9;
    color: #363636;
    margin-right: 100px;
    white-space: pre-line;
}

.civ-message-body.to + .civ-message-body.to,
.civ-message-body.from + .civ-message-body.from {
    margin-top: -10px;
}

.civ-message-suggestion {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 5px;
}

.civ-message-suggestion label {
    cursor: pointer;
    padding: 4px 10px;
    color: #6e5eff;
    border: 1px solid #6e5eff;
    border-radius: 2rem;
    font-weight: 500;
}
`, "",{"version":3,"sources":["webpack://./src/app/afterLogin/createInteractiveVideo/create-video-chat/create-video-chat.component.css"],"names":[],"mappings":";AACA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,WAAW;IACX,SAAS;IACT,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,iBAAiB;IACjB,YAAY;IACZ,0BAA0B;AAC9B;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,qBAAqB;IACrB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;AACpB","sourcesContent":["\n.add-pathways-container {\n    height: 82%;\n    width: 460px;\n    position: fixed;\n    z-index: 99;\n    top: 70px;\n    right: 5px;\n}\n\n.add-pathways-container .path-img {\n    border-radius: 13px;\n    max-height: 250px;\n    width: 100%;\n}\n\n.civ-remove {\n    background: #d3d3d3;\n    position: absolute;\n    top: 0;\n    right: 0;\n    padding: 5px 10px;\n    border: none;\n    border-radius: 0 6px 0 6px;\n}\n\n.civ-paths-btn {\n    background: rgba(100, 56, 180, 0.05);\n    border: 1px solid #6438B4;\n    border-radius: 50px;\n    font-weight: 500;\n    font-size: 14px;\n    color: #6438B4;\n    padding: 6px 16px;\n    margin: 5px;\n}\n\n.civ-paths-btn i {\n    display: none;\n    cursor: pointer;\n    margin-right: -5px;\n    margin-left: 5px;\n}\n\n.civ-paths-btn:hover i {\n    display: inline-block;\n}\n\n.civ-message-body {\n    display: flex;\n}\n\n.civ-message-body.from {\n    justify-content: flex-start;\n}\n\n.civ-message-body.to {\n    justify-content: flex-end;\n}\n\n.civ-message {\n    display: inline-block;\n    border-radius: 1.5rem;\n    margin-bottom: 15px;\n    padding: 8px 20px;\n    position: relative;\n    /*font-size: 20px;*/\n}\n\n.civ-message-body.to .civ-message {\n    background-color: #9b4dca;\n    color: #fff;\n    margin-left: 100px;\n}\n\n.civ-message-body.from .civ-message {\n    background-color: #E5E4E9;\n    color: #363636;\n    margin-right: 100px;\n    white-space: pre-line;\n}\n\n.civ-message-body.to + .civ-message-body.to,\n.civ-message-body.from + .civ-message-body.from {\n    margin-top: -10px;\n}\n\n.civ-message-suggestion {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 5px;\n}\n\n.civ-message-suggestion label {\n    cursor: pointer;\n    padding: 4px 10px;\n    color: #6e5eff;\n    border: 1px solid #6e5eff;\n    border-radius: 2rem;\n    font-weight: 500;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
